var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("AUTOMATION")]),_vm._v(" "+_vm._s(this.$route.query.automationID)+" "+_vm._s(this.$route.query.automationName)+" "),_c('div',[_vm._v(" day card placeholder ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }